export default{

    'title': '** Dental Hub **',
    'token': window.localStorage.getItem("token"),
    'users': [],
    'successmessage':'',
    'errormessage':'',
    'message':'',
    'geography': [],
    // 'visualizations':'',
    // 'visualizations1':'',
    'adminusername':'',
    'wards_obj':[],
    // 'address_obj':'',
    'role_obj':[],
    'loginvisualization':'',

    'overviewtable_obj':"",
    'treatment_by_activity_obj':"",
    'treatment_by_ward_obj':"",
    'overviewbargraph_obj':[],
    'overviewpiechart_obj':[],
    'overviewlinechart_obj':"",

    'preventionrati_obj':[],
    'earlyintervention_obj':[],
    'recalldistribution_obj':[],
    'treatment_tablebasicdata_obj':[],

    'overviewbargraphpost_obj':[],



    'treatmenttablebasic_obj':'',
    'treatmentstrategicdata_obj':'',


    'sectionaltable_obj':[],
    'treatmentvisualizationbarchart':[],

    'loginvisualization1':"",
    'activities_obj':[],
    'longitudinalmeasures_obj':[],
    'longitudinalmeasures_obj1':[],

    'dashboard_piechartpost':[],
    'returndate_obj':[],
}
